<template>
  <notifications
    class="tm-notifications"
    width="430"
    :group="notificationGroups.main"
    :style="notificationTopOffset ? { marginTop: notificationTopOffset } : undefined"
  >
    <template v-slot:body="props">
      <component
        :is="props.item.data.component ?? TmNotification"
        :type="props.item.type"
        :title="props.item.title"
        :text="props.item.text"
        @close="props.close()"
      />
    </template>
  </notifications>
</template>

<script setup lang="ts">
import { notificationGroups } from '@/services/types'
import TmNotification from '@/components/shared/notifications/TmNotification.vue'
import { useNotificationPosition } from '@/composition/useNotificationPosition'

const { notificationTopOffset } = useNotificationPosition()
</script>

<style scoped lang="scss">
.tm-notifications {
  z-index: 6100; // modals + 100
  margin-top: 16px; // default value if notificationTopOffset is not set
  max-width: 100%;
}
</style>
